<app-menu></app-menu>

<main>
  <router-outlet></router-outlet>
</main>

<div class="container">
  <button class="scrollTop" (click)="top()" [ngClass]="{show: isSticky}">
    <svg style="height: 20px; width: 20px;" class="icon" viewBox="0 0 512 512" ><use xlink:href="#arrow-up" x="0" y="0" /></svg>
  </button>
</div>

<app-footer id="mainFooter"></app-footer>

<div class="hackMenu" [ngClass]="{ show: hackMenu }"></div>
